export const transactionData = {
  "transactions": [
    {
      "id": "1",
      "type": "Invoice",
      "doc": "RE-01248",
      "date": "19.12.2025",
      "channel": "eBill",
      "direction": "Send",
      "status": "FAILED"
    },
    {
      "id": "2",
      "type": "Invoice",
      "doc": "RE-00156",
      "date": "10.12.2025",
      "channel": "Print",
      "direction": "Send",
      "status": "FAILED"
    },
    {
      "id": "3",
      "type": "Order",
      "doc": "OR-99210",
      "date": "21.12.2025",
      "channel": "EDI",
      "direction": "Receive",
      "status": "COMPLETED"
    },
    {
      "id": "4",
      "type": "Delivery Note",
      "doc": "DN-44211",
      "date": "22.12.2025",
      "channel": "eMail",
      "direction": "Send",
      "status": "PENDING"
    }
  ]
};